import Image from 'next/image';
import { useContext, useEffect, useState } from 'react';
import { BsPencil } from 'react-icons/bs';
import { editTitle, postName } from '../../../apis/profile.api';
import { handleCheckChangeForm } from '../../../common/checkForm';
import { handleSubmitForm } from '../../../common/formCallApi';
import { degree } from '../../../constant/degree';
import { IModalProps as IProps } from '../../../interfaces/components/modal.interface';
import { IUserFullName } from '../../../interfaces/profile.interface';
import FormLayout from '../../../layouts/FormLayout/FormLayout2';
import AuthContext from '../../../state/auth/AuthContext';
import { useModal } from '../../../state/modal-provider/ModalProvider';
import PrimaryInput from '../../input/PrimaryInput';
import SelectInput from '../../input/SelectInput2';

const UsernameModal = ({
  defaultData,
  cancelCallback,
  isModalCancelled,
}: IProps) => {
  const [userFullname, setUserFullname] = useState<IUserFullName>({
    fullName: defaultData.info.fullName ?? '',
  });

  const [degreeState, setDegreeState] = useState<string>(
    defaultData.title ?? ''
  ); //BE endpoint is title

  const [isSubmit, setIsSubmit] = useState<boolean>(false);

  const { setLoading } = useContext(AuthContext);
  const { toast } = useModal();

  const handleSetState = (name: string, value: string) => {
    setUserFullname((state) => ({ ...state, [name]: value }));
  };

  const handlePostNameAndDegree = async ({
    fullName,
    degree,
  }: {
    fullName: string;
    degree: string;
  }) => {
    try {
      await postName({ fullName });
      await editTitle({ title: degree });
    } catch (error) {
      console.log(error);
      throw error;
    }
  };

  const submitForm = () =>
    handleSubmitForm({
      callback: () => setIsSubmit(true),
      requiredKeys: ['fullName'],
      data: {
        fullName: userFullname.fullName,
        degree: degreeState === 'null' ? '' : degreeState,
      },
      asyncFunc: handlePostNameAndDegree,
      id: '',
      formCancelCallBack: cancelCallback,
      toggleSuccessModalNoti: () => {
        toast.success({
          content: 'Cập nhật thông tin thành công.',
        });
      },
      toggleErrorModalNoti: () =>
        toast.error({
          content: 'Có lỗi xảy ra, vui lòng thử lại.',
        }),
      setLoading,
    });

  const handleToggleLeaveModal = () => {
    if (
      !handleCheckChangeForm(userFullname, {
        fullName: defaultData.info.fullName ?? '',
        degree: defaultData.title ?? '',
      })
    ) {
      toast.warning({
        deleteTitle: 'Thoát',
        cancelTitle: 'Ở lại',
        onDelete: () => cancelCallback && cancelCallback(false),
        title: 'Thay đổi chưa lưu',
        content:
          'Thay đổi của bạn chưa được lưu. Bạn vẫn muốn thoát mà không lưu?',
      });
    } else {
      cancelCallback && cancelCallback(false);
    }
  };

  // warning when leave modal
  useEffect(() => {
    if (isModalCancelled) {
      handleToggleLeaveModal();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isModalCancelled]);

  return (
    <FormLayout
      classname="relative"
      formName="Tên người dùng"
      deleteCallback={() => {}}
      saveCallback={submitForm}
      cancelCallback={handleToggleLeaveModal}
      disabledDeletButton={true}
      hideDeleteButton={true}
    >
      <div className="sm:py-4 flex-1 w-full h-full flex flex-col gap-5">
        <PrimaryInput
          icon={<BsPencil />}
          desc=""
          value={userFullname.fullName}
          error={isSubmit && !userFullname.fullName}
          inputName="fullName"
          isObject
          setValue={handleSetState}
        />
        {isSubmit && !userFullname.fullName && (
          <p className="text-red-500">Đây là trường bắt buộc!</p>
        )}
        <p className="text-secondary -mb-3">Học hàm - Học vị</p>
        <SelectInput
          data={degree}
          notReactIcon
          keepPlaceHolderIcon
          icon={
            <Image
              src={'/icons/GraduateCap.svg'}
              alt=""
              width={28}
              height={28}
            />
          }
          placeholderIcon={
            <Image
              src={'/icons/GraduateCap.svg'}
              alt=""
              width={28}
              height={28}
            />
          }
          setValue={setDegreeState}
          value={degreeState}
          error={false}
          placeholder="Chọn Học hàm - Học vị"
        />
      </div>
    </FormLayout>
  );
};

export default UsernameModal;
